import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typependidikan";
var post = "/typependidikan";
export const actGetDataTypePendidikan = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEPENDIDIKAN_TYPEPENDIDIKAN" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypePendidikan = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEPENDIDIKAN_TYPEPENDIDIKAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type education has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEPENDIDIKAN", open: false })
          );
          return dispatch(actGetDataTypePendidikan());
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypePendidikan = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEPENDIDIKAN_TYPEPENDIDIKAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type education has been Updated");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEPENDIDIKAN", open: false })
          );
          return dispatch(actGetDataTypePendidikan());
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypePendidikan = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEPENDIDIKAN_TYPEPENDIDIKAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
            message: "Success get data",
          });
        }
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypePendidikan = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEPENDIDIKAN_TYPEPENDIDIKAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type education has been deleted");
          return dispatch(actGetDataTypePendidikan());
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPENDIDIKAN_TYPEPENDIDIKAN",
          message: "Network error..",
        });
      });
  };
};
